import { createSlice } from "@reduxjs/toolkit";
import {
  getVehicles,
  getVehicle,
  addVehicle,
  updateVehicle,
  addVehicleImages,
  publishVehicle
} from "./thunk";

export const initialState = {
  pagedVehicles: [],
  paginationInfo: {},
  vehicleDetails: "",
  error: {},
  pageRequest: { page: 1, size: 25, statusFilter: 1, searchInput: null }
};

const VehicleSlice = createSlice({
  name: "VehicleSlice",
  initialState,
  reducer: {},
  extraReducers: (builder) => {   
    builder.addCase(publishVehicle.fulfilled, (state, action) => {
          if(action.payload != "There was a problem!"){
            state.pagedVehicles = state.pagedVehicles.map(part =>
              part.id === action.payload.id ? { ...part, ...action.payload } : part
            );
            state.vehicleDetails = action.payload;
            sessionStorage.setItem("vehicleDetails", JSON.stringify(state.vehicleDetails));
            sessionStorage.setItem("pagedVehicles", JSON.stringify(state.pagedVehicles));
          }
        });

    builder.addCase(getVehicles.fulfilled, (state, action) => {
      state.pagedVehicles = action.payload.response;
      state.paginationInfo = {
        currentPage: action.payload.page,
        currentPageSize: action.payload.size,
        totalRows: action.payload.totalRows,
        totalPages: action.payload.totalPages
      };
      state.pageRequest = { 
        page: action.payload.page, 
        size: action.payload.size, 
        statusFilter: action.payload.statusFilter, 
        searchInput: action.payload.searchInput
      };
      sessionStorage.setItem("pagedVehicles", JSON.stringify(state.pagedVehicles));
      sessionStorage.setItem("vehiclePaginationInfo", JSON.stringify(state.paginationInfo));
      sessionStorage.setItem("vehiclePageRequest", JSON.stringify(state.pageRequest));
    });

    builder.addCase(getVehicle.fulfilled, (state, action) => {
      state.vehicleDetails = action.payload;
      sessionStorage.setItem("vehicleDetails", JSON.stringify(state.vehicleDetails));
    });

    builder.addCase(addVehicle.fulfilled, (state, action) => {
      state.pagedVehicles.unshift(action.payload);
      sessionStorage.setItem("pagedVehicles", JSON.stringify(state.pagedVehicles));
    });

    builder.addCase(updateVehicle.fulfilled, (state, action) => {
      state.pagedVehicles = state.pagedVehicles.map(vehicle =>
        vehicle.id === action.payload.id ? { ...vehicle, ...action.payload } : vehicle
      );
      state.vehicleDetails = action.payload;
      sessionStorage.setItem("vehicleDetails", JSON.stringify(state.vehicleDetails));
      sessionStorage.setItem("pagedVehicles", JSON.stringify(state.pagedVehicles));
    });
    
    builder.addCase(addVehicleImages.fulfilled, (state, action) => {
      state.pagedVehicles = state.pagedVehicles.map(vehicle =>
        vehicle.id === action.payload.id ? { ...vehicle, ...action.payload } : vehicle
      );
      state.vehicleDetails = action.payload;
      sessionStorage.setItem("vehicleDetails", JSON.stringify(state.vehicleDetails));
      sessionStorage.setItem("pagedVehicles", JSON.stringify(state.pagedVehicles));
    });

    builder.addCase(getVehicles.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(getVehicle.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(addVehicle.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(updateVehicle.rejected, (state, action) => { state.error = action.payload || null; });
    builder.addCase(addVehicleImages.rejected, (state, action) => { state.error = action.payload || null; });
  },
});

export default VehicleSlice.reducer;